var t = /* @__PURE__ */ ((e) => (e.Medium = "medium", e.Small = "small", e))(t || {});
const m = [
  "date",
  "datetime-local",
  "month",
  "time",
  "week"
];
export {
  t as SizesEnum,
  m as TYPES_WITH_DEFAULT_PLACEHOLDER
};
